import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import './flow-button.css';

// Ivan's Flow Button animation, with existing site colors and native link/form behavior.
export const FlowButton = forwardRef(function FlowButton({ text = 'Modern Button',
  children, as, to, href, type, className = '', showArrow = true, ...props
}, ref) {
  const Action = as || (to ? Link : href ? 'a' : 'button');
  const actionProps = to ? { to } : href ? { href } : {};
  return <Action {...props} {...actionProps} {...(type || Action === 'button' ? { type: type || 'button' } : {})}
    ref={ref} className={`flow-button ${className}`} data-flow-arrow={showArrow}>
    {showArrow && <ArrowRight aria-hidden="true" className="flow-button__arrow flow-button__arrow--enter" />}
    <span className="flow-button__label">{children ?? text}</span>
    <span aria-hidden="true" className="flow-button__circle" />
    {showArrow && <ArrowRight aria-hidden="true" className="flow-button__arrow flow-button__arrow--exit" />}
  </Action>;
});
